"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const styles_1 = __importDefault(require("../../styles/styles"));
const theme_1 = __importDefault(require("../../styles/theme"));
const icon_1 = __importStar(require("../icon/icon"));
const input_1 = require("../input/input");
const touchableElement_1 = __importDefault(require("../pressables/touchableElement"));
const text_1 = __importStar(require("../text/text"));
const imageInputStyles_1 = __importDefault(require("./imageInputStyles"));
const ClipInputComponent = ({ onPress, showError, image, toUploadTitle, eventName, }) => (react_1.default.createElement(touchableElement_1.default, { onPress: onPress, eventName: eventName },
    react_1.default.createElement(react_native_paper_1.TextInput, { mode: "outlined", error: showError, 
        // style={generalStyles.textInput}
        theme: input_1.themePaper, autoCapitalize: "none", editable: false, label: image.uri ? toUploadTitle : '', value: image.uri ? image.fileName : toUploadTitle, render: () => (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.flexDirectionRow, { paddingHorizontal: 5 }] },
            react_1.default.createElement(react_native_1.View, { style: imageInputStyles_1.default.text },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: theme_1.default.colors.COLOR_GRAY }, image.uri ? image.fileName : toUploadTitle)),
            react_1.default.createElement(react_native_1.View, { style: image.uri ? imageInputStyles_1.default.selectedContainer : imageInputStyles_1.default.iconContainer },
                react_1.default.createElement(icon_1.default, { name: image.uri ? icon_1.CHECK_VECTOR : icon_1.CLIP_VECTOR })))) })));
exports.default = ClipInputComponent;
